import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface DanhMucChiTieu {
  name: string;
  api_token: string;
}

export interface DanhMucChiTieuListInfor {
  errors: unknown;
  danhMucChiTieu: DanhMucChiTieu;
  isAuthenticated: boolean;
}

@Module
export default class DanhMucChiTieuModule
  extends VuexModule
  implements DanhMucChiTieuListInfor
{
  errors = {};
  danhMucChiTieu = {} as DanhMucChiTieu;
  isAuthenticated = !!JwtService.getToken();

  get danhMucChiTieus() {
    return this.danhMucChiTieuListData;
  }

  @Mutation
  [Mutations.DANHMUC_CHITIEU_LIST_DATA](danhMucChiTieus) {
    this.danhMucChiTieuListData = danhMucChiTieus;
  }

  @Action
  [Actions.DANHMUC_CHITIEU_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/dmchitieu/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.DANHMUC_CHITIEU_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DANHMUC_CHITIEU_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/dmchitieu", payload)
        .then((data) => {
          this.context.commit(Mutations.DANHMUC_CHITIEU_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DANHMUC_CHITIEU_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "gis/dmchitieu",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.DANHMUC_CHITIEU_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DANHMUC_CHITIEU_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("gis/dmchitieu", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.DANHMUC_CHITIEU_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  get dmChiTieuDetail() {
    return this.danhMucChiTieuDetailData;
  }

  @Mutation
  [Mutations.DANHMUC_CHITIEU_DETAIL_DATA](dmChitieuDetail) {
    this.danhMucChiTieuDetailData = dmChitieuDetail;
  }
  @Action
  [Actions.DANHMUC_CHITIEU_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/gis/dmchitieu",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.DANHMUC_CHITIEU_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
